
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import QRCode from 'qrcodejs2';
	import PickerDate from '@/components/picker-date.vue';

	import {
		expressQueryOrderServicePageInfo,
		applyPayExpressQueryPackage,
		buyExpressQueryPackageResult,
		expressQueryStatistic,
		expressQueryOrderPageList
	} from '@/api/order';

	import {
		getSearchDate,
		nextDay
	} from "@/utils/index"

	@Component({
		name: 'logisticsTracking',
		components: {
			PageFooter,
			RadioButton,
			PickerDate
		}
	})

	export default class logisticsTracking extends Vue {
		
		
		private expressQueryCount = 0;
		private visible = false;

		private radioType = 1
		private radioList = [{
				value: 1,
				label: '订购服务'
			},
			{
				value: 2,
				label: '查询统计'
			},
			{
				value: 3,
				label: '订购记录'
			},
		]
		private combo = -1;
		private combolist = []
		private paytype = 1;
		private payData: any = {};
		
		private filterTime: any = '';
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private tableData:any = [];
		private allOrderCount = 0;
		private allQueryCount = 0;
		private timer:any = ''
		private qrcode:any = {}


		private mounted() {
			this.filterTime = getSearchDate(1).join('/');

			this.init();
		}
		
		private beforeDestroy(){
			this.timer &&clearTimeout(this.timer)
		}

		private async init() {
			let res: any = await expressQueryOrderServicePageInfo({})
			if (res.IsSuccess) {
				this.expressQueryCount = res.Result.ExpressQueryCount;
				this.combolist = res.Result.PackageList;
			}
		}

		private changetype(e) {
			if(e==1){
				this.paytype = 1
				this.combo = -1
				this.init()
			}else{
				this.timer &&clearTimeout(this.timer)
				if (e == 2){
					this.pageNo = 1;
					this.getExpressQueryStatistic();
				}
				if (e == 3){
					this.pageNo = 1;
					this.getExpressQueryOrderPageList();
				}
			}
		}

		/**
		 * 确认购买
		 */
		private async handleSure() {
			if (this.combo < 0) {
				this.$message.error('请选择订购套餐');
				return;
			}
			
			this.timer &&clearTimeout(this.timer)

			let itemObj: any = this.combolist[this.combo];
			let res: any = await applyPayExpressQueryPackage(itemObj)
			if (res.IsSuccess) {
				this.paytype = 2;
				this.payData = res.Result;
				this.payData.payMoney = itemObj.Price;
				this.$nextTick(() => {
					this.getCreateQRCode();
					this.checkPayResult();
				})

			}
		}

		/**
		 * 生成二维码
		 */
		private getCreateQRCode() {
			// console.log(this.qrcode)
			if(this.qrcode&&this.qrcode._el){
				// this.qrcode.clear();
				document.getElementById('qrcode').innerHTML = ''
			}
			this.qrcode = new QRCode("qrcode", {
				text: this.payData.QrcodeUrl,
				width: 160,
				height: 160,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRCode.CorrectLevel.H
			});
		}

		/**
		 * 轮询获取支付结果
		 */
		private async checkPayResult() {
			let res: any = await buyExpressQueryPackageResult({
				PayOrderNo: this.payData.PayOrderNo
			})

			if (res.IsSuccess) {
				if (res.Result.IsPay) {
					this.visible = true;
					this.timer &&clearTimeout(this.timer)
					setTimeout(() => {
						// this.$router.back()
						this.paytype = 1;
						this.init();
					}, 1500)
				} else {
					this.timer = setTimeout(() => {
						this.checkPayResult();
					}, 1000)
				}
			}else{
				this.timer &&clearTimeout(this.timer);
			}
		}
		
		/**
		 * 取消支付
		 */
		private handleCancelPay(){
			this.paytype = 1;
			this.timer &&clearTimeout(this.timer);
			// console.log(this.timer)
		}
		
		/**
		 * 获取物流查询统计列表
		 */
		private async getExpressQueryStatistic(){
			
			let params:any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
			}
			
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = dt[1]?(nextDay(dt[1],1)):'';
			}
			
			let res: any = await expressQueryStatistic(params);
			
			if(res.IsSuccess){
				this.total = res.Result.Total;
				this.allOrderCount = res.Result.AllOrderCount;
				this.allQueryCount = res.Result.AllQueryCount;
				this.tableData = res.Result.Results;
			}
			
		}
		
		/**
		 * 订购记录
		 */
		private async getExpressQueryOrderPageList(){
			let params:any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
			}
			
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = dt[1]?(nextDay(dt[1],1)):'';
			}
			
			let res: any = await expressQueryOrderPageList(params);
			if(res.IsSuccess){
				this.total = res.Result.Total;
				this.tableData = res.Result.Results;
			}
		}
		
		/**
		 * 页码改变事件
		 */
		private changePage(e) {
			this.pageNo = +e;
			if (this.radioType == 2){
				this.getExpressQueryStatistic();
			}
			if (this.radioType == 3){
				this.getExpressQueryOrderPageList();
			}
		}
		
		/**
		 * 搜索
		 */
		private doSearch(){
			this.pageNo = 1;
			if (this.radioType == 2){
				this.getExpressQueryStatistic();
			}
			if (this.radioType == 3){
				this.getExpressQueryOrderPageList();
			}
		}
		
		/**
		 * 清空
		 */
		private clearSearch(){
			this.pageNo = 1;
			this.filterTime = getSearchDate(1).join('/');
			if (this.radioType == 2){
				this.getExpressQueryStatistic();
			}
			if (this.radioType == 3){
				this.getExpressQueryOrderPageList();
			}
		}
		
		
	}
